
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/confirm-email",
      function () {
        return require("private-next-pages/auth/confirm-email.js");
      }
    ]);
  